import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  Overlay,
  OverlayConfig,
  OverlayRef,
  PositionStrategy
} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Injectable()
export class LoadingService {
  displayProgressSpinner: BehaviorSubject<boolean>;

  constructor(private overlay: Overlay) {
    this.displayProgressSpinner = new BehaviorSubject<boolean>(null);
  }

  createOverlay(config: OverlayConfig): OverlayRef {
    return this.overlay.create(config);
  }
  attachTemplatePortal(
    overlayRef: OverlayRef,
    templateRef: TemplateRef<any>,
    vcRef: ViewContainerRef
  ) {
    const templatePortal = new TemplatePortal(templateRef, vcRef);
    overlayRef.attach(templatePortal);
  }
  positionGloballyCenter(): PositionStrategy {
    return this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();
  }

  public setDisplayInProgress(value: boolean) {
    this.displayProgressSpinner.next(value);
  }

  public get getDisplayInProgress(): boolean {
    return this.displayProgressSpinner.value;
  }
}
